import React from 'react';
import { useFaqData } from './useFAQData';
import st from './style.module.scss';
import { useTranslation } from 'react-i18next';

const FaqInstructionSection = ({ type }) => {
  const { i18n } = useTranslation();
  const isUzLanguage = i18n.language === 'uz';
  const { getInstructionsData } = useFaqData();
  const INSTRUCTIONS = getInstructionsData();
  const { header, description, steps } = INSTRUCTIONS[type];
  return (
    <section className={st.instructionSection}>
      <div className={st.instructionSectionContainer}>
        <h3>{header}</h3>
        <p>{description}</p>
        <div>
          <ol>
            {steps.map(step => (
              <li key={step.key} className={st.instructionSectionList}>
                {!isUzLanguage && (
                  <>
                    {step.title}{' '}
                    {step.url && (
                      <a
                        className={st.instructionSectionLink}
                        href={step.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        career.uwed.uz
                      </a>
                    )}
                  </>
                )}
                {isUzLanguage && (
                  <>
                    {step.url && (
                      <a
                        className={st.instructionSectionLink}
                        href={step.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        career.uwed.uz
                      </a>
                    )}
                    {step.title}
                  </>
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default FaqInstructionSection;
